import Vue from 'vue';

const state = {};

const mutations = {};

const actions = {
  async fetchReleasesPg({dispatch}) {
    const {data, status} = await Vue.axios.get ('/pg_releases');
    if (status != 200) {
      await dispatch ('generateSnackBarMessage', {
        message: 'Ocurrió un error al obtener los rubros',
        type: 'error',
      });
    }
    return {data, status};
  },
  async updateReleasesPg ({dispatch}, releasesPg) {
    const formData = new FormData ();
    formData.append ('title_cover_page', releasesPg.title_cover_page);
    if (releasesPg.file_cover_page) {
      formData.append ('file_cover_page', releasesPg.file_cover_page);
    }
    const {data, status} = await Vue.axios.post (
      `/pg_releases/${releasesPg.id}`,
      formData
    );
    if (status != 200 && status != 201 && status != 204) {
      await dispatch ('createResponseMessage', {
        message: data.message ||
          'Ocurrió un error actualizando los datos del rubro',
        type: 'error',
      });
    } else {
      await dispatch ('generateSnackBarMessage', {
        message: data.message || 'Se guardó correctamente',
        type: 'success',
      });
    }
    return {data, status};
  },
};

export default {state, mutations, actions};
